// extracted by mini-css-extract-plugin
export default {"content":"DrugsFilePage_content__6iKzV","drugsSearch":"DrugsFilePage_drugsSearch__vOhYY","drugsSearchWide":"DrugsFilePage_drugsSearchWide__W4v+G"};